/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable no-nested-ternary */
import { Avatar, styled } from '@material-ui/core';
import { ChatMessageContact as MessageContact } from '@src/types';
import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import ChatMessageContactActions from './ChatMessageContactActions';
import ChatMessageContactBtn from './ChatMessageContactActions/ChatMessageContactBtnStyle';
import ChatMessageContactsDialog from './ChatMessageContactsDialog';
import usePrimaryContactPhone from './hooks/usePrimaryContactPhone';

export type ChatMessageContactProps = {
  contacts: MessageContact[] | undefined;
};

const ChatMessageContact: React.FC<ChatMessageContactProps> = ({
  contacts,
}) => {
  const { formatMessage } = useIntl();
  const primaryContact = useMemo(() => contacts?.at(0), [contacts]);
  const primaryPhone = usePrimaryContactPhone(primaryContact);

  const qtyContacts = useMemo(() => contacts?.length || 0, [contacts]);
  const hasMoreOnceContact = useMemo(() => qtyContacts > 1, [qtyContacts]);
  const contactFullName = useMemo(
    () =>
      `${primaryContact?.name.first_name} ${
        primaryContact?.name?.last_name || ''
      }`,
    [primaryContact]
  );

  const [isOpenContactsModal, setIsOpenContactsModal] = useState(false);

  if (!primaryContact || !primaryPhone) return null;

  return (
    <ChatmessageContactStyles>
      <div className="contact-content">
        <Avatar style={{ width: 32, height: 32 }} />
        <span
          role="button"
          className="contact-title"
          onClick={() => setIsOpenContactsModal(true)}
        >
          {contacts && hasMoreOnceContact
            ? formatMessage(
                { id: 'Console.ContactMessage.OthersContacts' },
                { name: contactFullName, qty: qtyContacts - 1 }
              )
            : contactFullName}
        </span>
      </div>
      <div className="contact-actions">
        {hasMoreOnceContact ? (
          <ChatMessageContactBtn
            type="button"
            className="contact-btn"
            onClick={() => setIsOpenContactsModal(true)}
          >
            {formatMessage({ id: 'Console.ContactMessage.ShowContacts' })}
          </ChatMessageContactBtn>
        ) : (
          <ChatMessageContactActions
            contact={primaryContact}
            activePhone={primaryPhone}
          />
        )}
      </div>

      <ChatMessageContactsDialog
        contacts={contacts || []}
        isOpenContactsDialog={isOpenContactsModal}
        onCloseContactsDialog={() => setIsOpenContactsModal(false)}
      />
    </ChatmessageContactStyles>
  );
};

export const ChatmessageContactStyles = styled('div')(({ theme }) => ({
  minWidth: 280,
  maxWidth: 330,
  borderRadius: 6,
  border: theme.palette.type === 'dark' ? 'none' : '1px solid #e6e6e6',

  '& .contact-content': {
    gridGap: 13,
    display: 'flex',
    fontWeight: 500,
    alignItems: 'center',
    fontSize: '.95rem',
    backgroundColor: theme.palette.type === 'dark' ? 'transparent' : '#F4F4F5',
    padding: '15px 20px',

    '& .contact-title': {
      cursor: 'pointer',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },

  '& .contact-actions': {
    display: 'flex',
    borderRadius: 6,
    overflow: 'hidden',
    width: '100%',
    height: 40,

    '& button': {
      flexGrow: 1,
    },
  },
}));

export default ChatMessageContact;
